'use client';

import { createContext } from 'react';

import type { PopoverFloatingContextInterface } from '../types/use-popover.types';

export const PopoverFloatingContext = createContext({} as PopoverFloatingContextInterface);

PopoverFloatingContext.displayName = 'Popover.Floating.Context';
